/* eslint-disable camelcase */
export const FeatureFlagNames = {
  REQUIRE_PASSWORD_CHANGE_ENABLED: 'require_password_change_enabled',
} as const;

export type FeatureFlagName = ReverseMap<typeof FeatureFlagNames>
export type FeatureFlagsMap = Partial<Record<FeatureFlagName | string, boolean | string | number>>;

type FeatureFlagDto = {
  name: string;
  value: string;
  value_type?: string;
};

export type FeatureFlagsResponse = {
  features?: FeatureFlagDto[];
};

const normalizeFeatureFlagValue = (feature: FeatureFlagDto) => {
  if (feature.value_type === 'boolean') {
    return String(feature.value).toLowerCase() === 'true';
  }

  if (feature.value_type === 'number') {
    const value = Number(feature.value);
    return Number.isNaN(value) ? feature.value : value;
  }

  return feature.value;
};

export const normalizeFeatureFlags = (response: FeatureFlagsResponse = {}):
	FeatureFlagsMap => (response.features || []).reduce<FeatureFlagsMap>((acc, feature) => {
    acc[feature.name] = normalizeFeatureFlagValue(feature);
    return acc;
  }, {});

export const isFeatureEnabled = (
  featureFlags: FeatureFlagsMap | null,
  featureName: FeatureFlagName | string,
) => Boolean(featureFlags?.[featureName]);

export const isAnyFeatureEnabled = (
  featureFlags: FeatureFlagsMap | null,
  featureNames: Array<FeatureFlagName | string>,
) => featureNames.some(featureName => isFeatureEnabled(featureFlags, featureName));
